export default __webpack_public_path__ + "static/media/cha3.6e338b35.png";